import { render } from "./InputName.vue?vue&type=template&id=2585a62c"
import script from "./InputName.vue?vue&type=script&lang=js"
export * from "./InputName.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mathe\\Desktop\\matheogirard.fr\\front-pi_air-v2.matheogirard.fr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__